import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';
import FixedRecordRow from './fixed_record_row';

import { getCurrentStep } from '../store/record_table_ui_selectors';
import { getRecordIds, getRecords } from '../store/run_records_selectors';
import { recordStatuses } from '../preview/import_constants';

export function FixedRecordsTable({
  currentStep,
  recordIds,
  records,
}) {
  const previewStep = () => currentStep === 'preview';

  const allValidImports = () => {
    return Object.values(records).every((record) => {
      return record.previewStatus === recordStatuses['success'];
    });
  };

  const renderFixedCells = () => {
    const validImports = allValidImports();

    return recordIds.map((id) => {
      return (
        <FixedRecordRow
          allValidImports={validImports}
          key={id}
          record={records[id]}
        />
      );
    });
  };

  const renderHeaders = () => {
    const validImports = allValidImports();

    return (
      <React.Fragment>
        <th className="table-cell text-center"></th>
        {previewStep()
          ? (
            <React.Fragment>
              <th className="table-cell"></th>
              {!validImports && <th className="table-cell"></th>}
            </React.Fragment>
          )
          : (
            <React.Fragment>
              <th className="table-cell">Action</th>
              <th className="table-cell"></th>
            </React.Fragment>
          )
        }
      </React.Fragment>
    );
  };

  return (
    <div className="fixed-table-container">
      <Table className="records-table mb-0">
        <thead className="records-header">
          <tr>
            {renderHeaders()}
          </tr>
        </thead>
        <tbody className="records-body">
          {renderFixedCells()}
          <tr className="empty-scrollable-space">
            <td colSpan="3"></td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}

FixedRecordsTable.propTypes = {
  currentStep: PropTypes.string.isRequired,
  recordIds: PropTypes.array.isRequired,
  records: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  currentStep: getCurrentStep(state),
  recordIds: getRecordIds(state),
  records: getRecords(state)
});

export default connect(mapStateToProps, null)(FixedRecordsTable);
